'use es6';

import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { LegalConsentOptions, LEGAL_CONSENT_OPTIONS_KEY } from 'FormsCommonComponents/constants/LegalConsent';
import { getSubscriptionDefinitions as _getSubscriptionDefinitions, getDefaultCopyForLegalConsent as _getDefaultCopyForLegalConsent } from 'FormsCommonComponents/actions/LegalConsent';
import { updateMetaData } from 'FormsUI/actions/FormDefinition';
import { resetSelectedFormItem } from 'FormsUI/actions/FormSelection';
import { SpecialFieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { getDefaultOptions } from 'FormsUI/selectors/LegalConsent';
import { getPortal } from 'FormsUI/selectors/Portal';
import { getSelectedFormItemType } from 'FormsUI/selectors/FormSelection';
import { hasBusinessUnitAccess as hasBusinessUnitAccessFromSelector } from 'FormsUI/selectors/Scope';
import { buildLegalConsent } from 'FormsCommonComponents/utils/LegalConsent';
import updateLegalConsentOption from 'FormsUI/actions/LegalConsent/updateLegalConsentOption';
import getSubscriptionsForLegalConsent from 'FormsUI/selectors/legalConsent/getSubscriptionsForLegalConsent';
import { trackUpdateGdprPropertyDebounced, trackDeleteGdprCheckbox } from 'FormsUI/tracking/legalConsentTracking';
import { getBusinessUnitId } from 'FormsUI/selectors/FormDefinition';
import { isUngatedForCampaignBusinessUnit as getIsUngatedForCampaignBusinessUnit } from 'FormsUI/selectors/Gates';
import { removeLegalConsentErrors } from 'FormsUI/actions/FormDefinition';
export const buildLegalConsentAction = (getState, option, lang) => {
  const state = getState();
  const defaultOptions = getDefaultOptions(state, lang);
  const _ref = defaultOptions || {},
    defaultTexts = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  const {
    domain
  } = getPortal(state);
  const subscriptionDefinitions = getSubscriptionsForLegalConsent(state);
  return buildLegalConsent({
    option,
    defaultOptions,
    defaultTexts,
    communicationConsentCheckboxes: defaultOptions ? defaultOptions.communicationConsentCheckboxes : null,
    subscriptionDefinitions,
    domain
  });
};
export const removeLegalConsent = () => (dispatch, getState) => {
  const selectedFormItemType = getSelectedFormItemType(getState());
  const isLegalConsent = selectedFormItemType === SpecialFieldTypes.LEGAL_CONSENT;
  if (isLegalConsent) {
    dispatch(resetSelectedFormItem());
  }
  dispatch(removeLegalConsentErrors());
  return dispatch(updateLegalConsentOption(LegalConsentOptions.NONE));
};
export const updateLegalConsent = legalConsent => dispatch => dispatch(updateMetaData(LEGAL_CONSENT_OPTIONS_KEY, legalConsent));
export const updateLegalConsentProperty = (legalConsent, key, value) => dispatch => {
  trackUpdateGdprPropertyDebounced(key);
  dispatch(updateMetaData(LEGAL_CONSENT_OPTIONS_KEY, legalConsent.set(key, value)));
};
export const removeLegalConsentCheckbox = (legalConsent, checkbox) => dispatch => {
  trackDeleteGdprCheckbox();
  dispatch(updateLegalConsent(legalConsent.removeCheckbox(checkbox)));
};
export const getSubscriptionDefinitions = () => (dispatch, getState) => {
  const state = getState();
  const businessUnitId = getBusinessUnitId(state);
  const hasBusinessUnitsAccess = hasBusinessUnitAccessFromSelector(state);
  const isUngatedForCampaignBusinessUnit = getIsUngatedForCampaignBusinessUnit(state);
  dispatch(_getSubscriptionDefinitions({
    businessUnitId,
    hasBusinessUnitsAccess,
    isUngatedForCampaignBusinessUnit
  }));
};
export const getDefaultCopyForLegalConsent = _getDefaultCopyForLegalConsent;